import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const navigationType = useNavigationType(); // این هوک می‌گوید کاربر جلو رفته یا عقب

  useEffect(() => {


    // اگر کاربر دکمه Back یا Forward را زده، کاری نکن (اسکرول حفظ شود)
    if (navigationType === "POP") {
      return;
    }

    // فقط وقتی کاربر روی لینک کلیک کرده (PUSH)، اسکرول را به بالا ببر
    window.scrollTo(0, 0);
    
    // تاخیر برای صفحات سنگین (همان روش قبلی)
    const timeoutId = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);

    const timeoutId2 = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 500);

    return () => {
      clearTimeout(timeoutId);
      clearTimeout(timeoutId2);
    };
  }, [pathname, navigationType]);

  return null;
}